export enum OpportunityBoardFilterFields {
  opportunitySeatStartDate = 'opportunitySeatStartDate',
  opportunitySeatEndDate = 'opportunitySeatEndDate',
  positionName = 'positionName',
  teamName = 'teamName',
  teamCustomFields = 'teamCustomFields',
}
